// extracted by mini-css-extract-plugin
export default {"search-icon":"dwi7Z","dropdown":"al37u","dropdown--hidden":"nkR5n"};